"use client";

import { type ReactNode } from "react";
import { I18nProvider } from "./i18n/context";
import { AppTheme } from "@booking/core-ui/theme";

// AppTheme sits INSIDE I18nProvider because it reads `lang` from it, for MUI's
// own strings; the vertical's colour theme it takes from the server.
export function Providers({ children }: { children: ReactNode }) {
  return (
    <I18nProvider>
      <AppTheme surface="admin">{children}</AppTheme>
    </I18nProvider>
  );
}
